'use client';

import dynamic from 'next/dynamic';

// Dynamically import AnalyticsRouteTracker with SSR disabled
export const AnalyticsRouteTracker = dynamic(
  () => import('../components/AnalyticsRouteTracker'),
  { ssr: false },
);

// Dynamically import AuthCookieSync with SSR disabled
export const AuthCookieSync = dynamic(
  () => import('../components/AuthCookieSync'),
  { ssr: false },
);

// Dynamically import ChunkLoadErrorHandler with SSR disabled
export const ChunkLoadErrorHandler = dynamic(
  () => import('../components/ChunkLoadErrorHandler'),
  { ssr: false },
);
